import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import API from "../../utils/api";
import {message} from "antd";
import {useToken} from "../../app/hooks";
import {MobileSalePropertyDetail} from "./block/MobileSalePropertyDetail";
import {useNavigate} from "react-router";
import {SalePropertyTable} from "../RealEstate/SaleProperty/SalePropertyTable";
import {useAgentSaleList} from "../hooks/Agent/SaleProperty/GetAgentSaleList";

export const SaleImageMobile = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [order, setOrder] = useState('latest'); // latest, oldest
  const [searchWord, setSearchWord] = useState('');

  const [isDetailModal, setIsDetailModal] = useState(false)
  const [isSelectItem, setIsSelectItem] = useState(false);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [isAllChecked, setIsAllChecked] = useState(false);

  const { agentSaleList, mutateAgentSaleList, total, isLoading } = useAgentSaleList(page, pageSize, '광고중', order, searchWord, true);

  return (
    <Page>

      <SalePropertyTable
        isDetailModal={isDetailModal}
        setIsDetailModal={setIsDetailModal}
        setPage={setPage}
        page={page}
        setPageSize={setPageSize}
        pageSize={pageSize}
        agentSaleList={agentSaleList}
        mutateAgentSaleList={mutateAgentSaleList}
        total={total}
        setIsSelectItem={setIsSelectItem}
        isSelectItem={isSelectItem}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        isAllChecked={isAllChecked}
        setIsAllChecked={setIsAllChecked}
        isLoading={isLoading}
      />

    </Page>
  )
}

const Page = styled.div`
  width: 100%;
    padding-top: 50px;
`

